import React from 'react';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const TourismeSection = ({ dashboardData }) => {
    const totalCATourisme = Number(dashboardData?.totalPaiementTourisme) || 0;
    const totalCAReelTourisme = Number(dashboardData?.totalPaiementTourismeReel) || 0;
    const totalDeboursTourisme = Number(dashboardData?.totalFraisTourisme) || 0;
    const margeTourisme = totalCATourisme - totalDeboursTourisme;
    const margeReelleTourisme = totalCAReelTourisme - totalDeboursTourisme;
    const ecart = Math.abs(totalCATourisme - totalCAReelTourisme);
    const pourcentageRealisation = totalCATourisme > 0 ? ((totalCAReelTourisme / totalCATourisme) * 100).toFixed(1) : 0;
    const pourcentageMargePrev = totalCATourisme > 0 ? ((margeTourisme / totalCATourisme) * 100).toFixed(1) : 0;
    const pourcentageMargeReel = totalCAReelTourisme > 0 ? ((margeReelleTourisme / totalCAReelTourisme) * 100).toFixed(1) : 0;

    // Groupement par prestataire - assumons qu'on a des données prestataires dans dashboardData
    const prestataires = dashboardData?.prestataires || [];
    const prestataireStats = prestataires.map(prestataire => {
        const ca = Number(prestataire.ca) || 0;
        const debours = Number(prestataire.debours) || 0;
        const marge = ca - debours;
        const pourcentageCA = totalCATourisme > 0 ? ((ca / totalCATourisme) * 100).toFixed(1) : 0;
        const pourcentageMarge = ca > 0 ? ((marge / ca) * 100).toFixed(1) : 0;

        return {
            nom: prestataire.nom || 'Prestataire inconnu',
            ca,
            debours,
            marge,
            pourcentageCA,
            pourcentageMarge
        };
    }).sort((a, b) => b.ca - a.ca);

    return (
        <div className="analysis-section">
            <SectionHeader
                title="🌍 ANALYSE TOURISME"
                pdfData={[
                    { metrique: "CA Prévisionnel", montant: totalCATourisme, pourcentage: "100.0%", marge: margeTourisme },
                    { metrique: "CA Réel", montant: totalCAReelTourisme, pourcentage: `${pourcentageRealisation}%`, marge: margeReelleTourisme }
                ]}
                pdfFilename="analyse-tourisme.pdf"
                pdfTitle="Analyse Tourisme"
                pdfTableHeaders={["Indicateur", "Montant", "% Réalisation", "Marge"]}
            />

            <div className="table-container-prof">
                <div className="table-title-prof">SYNTHESE TOURISME GENERALE</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">INDICATEUR</th>
                            <th className="text-right">MONTANT</th>
                            <th className="text-right">DEBOURS</th>
                            <th className="text-right">MARGE</th>
                            <th className="text-right">% MARGE</th>
                            <th className="text-right">% REALISATION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-left"><strong>CA PREVISIONNEL</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCATourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeTourisme)}</td>
                            <td className="percentage-cell">{pourcentageMargePrev}%</td>
                            <td className="percentage-cell">100.0%</td>
                        </tr>
                        <tr>
                            <td className="text-left"><strong>CA REEL</strong></td>
                            <td className="currency-cell">{priceFormatterV3(totalCAReelTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(totalDeboursTourisme)}</td>
                            <td className="currency-cell">{priceFormatterV3(margeReelleTourisme)}</td>
                            <td className="percentage-cell">{pourcentageMargeReel}%</td>
                            <td className="percentage-cell">{pourcentageRealisation}%</td>
                        </tr>
                        <tr className="subtotal-row-prof">
                            <td className="text-left"><strong>ECART</strong></td>
                            <td className="currency-cell">{priceFormatterV3(ecart)}</td>
                            <td className="currency-cell">-</td>
                            <td className="currency-cell">{priceFormatterV3(Math.abs(margeTourisme - margeReelleTourisme))}</td>
                            <td className="percentage-cell">-</td>
                            <td className="percentage-cell">{(100 - parseFloat(pourcentageRealisation)).toFixed(1)}%</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {prestataireStats.length > 0 && (
                <div className="table-container-prof">
                    <div className="table-title-prof">CHIFFRE D'AFFAIRES, MARGE ET POURCENTAGE PAR PRESTATAIRE</div>
                    <table className="professional-table">
                        <thead>
                            <tr>
                                <th className="text-left">PRESTATAIRE</th>
                                <th className="text-right">CHIFFRE D'AFFAIRES</th>
                                <th className="text-right">DEBOURS</th>
                                <th className="text-right">MARGE</th>
                                <th className="text-right">% MARGE</th>
                                <th className="text-right">% DU CA TOTAL</th>
                            </tr>
                        </thead>
                        <tbody>
                            {prestataireStats.map((prestataire, index) => (
                                <tr key={index}>
                                    <td className="text-left"><strong>{prestataire.nom}</strong></td>
                                    <td className="currency-cell">{priceFormatterV3(prestataire.ca)}</td>
                                    <td className="currency-cell">{priceFormatterV3(prestataire.debours)}</td>
                                    <td className="currency-cell">{priceFormatterV3(prestataire.marge)}</td>
                                    <td className="percentage-cell">{prestataire.pourcentageMarge}%</td>
                                    <td className="percentage-cell">{prestataire.pourcentageCA}%</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr className="total-row-prof">
                                <td className="text-left"><strong>TOTAL</strong></td>
                                <td className="currency-cell">{priceFormatterV3(prestataireStats.reduce((sum, p) => sum + p.ca, 0))}</td>
                                <td className="currency-cell">{priceFormatterV3(prestataireStats.reduce((sum, p) => sum + p.debours, 0))}</td>
                                <td className="currency-cell">{priceFormatterV3(prestataireStats.reduce((sum, p) => sum + p.marge, 0))}</td>
                                <td className="percentage-cell">
                                    {prestataireStats.reduce((sum, p) => sum + p.ca, 0) > 0 ?
                                        ((prestataireStats.reduce((sum, p) => sum + p.marge, 0) / prestataireStats.reduce((sum, p) => sum + p.ca, 0)) * 100).toFixed(1) : 0}%
                                </td>
                                <td className="percentage-cell">100.0%</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TourismeSection;
